/**
 * Saudacao de abertura do treino de entrevista.
 *
 * Vaga anonima nao revela quem contrata, e a API devolve o nome da empresa
 * vazio nesse caso. Sem isso a frase virava "da empresa null" ou, pior,
 * nomeava a empresa que a vaga escondia: foi assim que o nome da contratante
 * apareceu no treino de uma vaga anonima, reportado em 21/09/2026.
 *
 * A regra e' a mesma que o produto ja usa no e-mail de reuniao: vaga anonima
 * simplesmente nao nomeia a empresa, em vez de dizer que ela existe e esta
 * oculta.
 */
export function buildInterviewGreeting(firstName, vacancyTitle, companyName) {
  const opening = `Olá ${firstName}, bem-vindo à entrevista para a vaga de ${vacancyTitle}`;

  return companyName ? `${opening}, da empresa ${companyName}!` : `${opening}!`;
}
